module.exports = __webpack_public_path__ + "2df2eeb0a0395cde92b0b88c17f45ea4.svg";